import React, { useState, Fragment } from "react"
import { useHistory } from "react-router-dom"
import { FaTrashAlt } from "react-icons/fa"
import { toast } from "react-toastify"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"

import { isInKioskMode } from "utils"
import { deletePrinter } from "@redux"
import { ConfirmationModal, IconButton } from "components"

const PrinterDeleteButton = props => {
  const { editMode, printerId } = props

  const [t] = useTranslation()

  const dispatch = useDispatch()

  const history = useHistory()

  const [sending, setSending] = useState(false)
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false)

  const handleDeletePair = async () => {
    setSending(true)

    try {
      dispatch(
        deletePrinter(printerId)
      )

      history.push(
        isInKioskMode() ? "/kiosk-settings" : "/settings",
        { initialTab: "printers" }
      )
    } catch (err) {
      console.log(err)

      setSending(false)

      toast.error(t("حذف_پرینتر_موفقیت_آمیز_نبود"))
    }
  }

  if (!editMode) return null

  return (
    <Fragment>
      <IconButton
        icon={FaTrashAlt}
        color="white"
        size={20}
        onClick={() => setShowDeleteConfirmationModal(true)}
      />
      <ConfirmationModal
        loading={sending}
        title={t("آیا_می_خواهید_این_پرینتر_را_حذف_کنین")}
        show={showDeleteConfirmationModal}
        onConfirm={handleDeletePair}
        onHide={() => setShowDeleteConfirmationModal(false)}
      />
    </Fragment>
  )
}

export default PrinterDeleteButton